import { render, staticRenderFns } from "./practices-card.vue?vue&type=template&id=59d9ab46"
import script from "./practices-card.vue?vue&type=script&lang=js"
export * from "./practices-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports